import common from "../common";
import Scene from "./Scene";

export default class PreloaderScene extends Scene {
    constructor() {
        super();

        this.loaded = 0;
        this._logo = null;
        this._barBk = null;
        this._bar = null;
        this._barOverlay = null;
        this._loading = null;
    }

    init() {
        super.init();

        const assets = P3.assets;

        //background
        const bk = new PIXI.Sprite(assets.texture('bg_preloader_pot'));
        bk.anchor.set(0.5);
        bk.width= 1900;
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(bk);

        const logo = new PIXI.Sprite(assets.texture('logo'));
        logo.anchor.set(0.5);
        logo.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 80);
        this.addChild(logo);

        let loadingbg = new PIXI.Sprite(P3.assets.texture('loader_back'));
        loadingbg.anchor.set(0.5);
        loadingbg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 250);
        this.addChild(loadingbg);

        this._loadingBar = new PIXI.Sprite(P3.assets.texture('loader_fill'));
        this._loadingBar.anchor.set(0.5);
        this._loadingBar.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 250);
        this.addChild(this._loadingBar);

        this._loadingMask = new PIXI.Graphics();
        this._loadingMask.beginFill(0xFF0000, 0.6);
        this._loadingMask.drawRect(
            this._loadingBar.x - this._loadingBar.width * 1.5,
            this._loadingBar.y - this._loadingBar.height * 0.5,
            this._loadingBar.width,
            this._loadingBar.height
        );
        this._loadingMask.endFill();
        this.addChild(this._loadingMask);
        this._loadingBar.mask = this._loadingMask;
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();
    }

    update() {
        this._loadingMask.x = this._loadingBar.width * this.loaded;
    }
}